<template>
    <div class="seo-subject-search">
        <div class="goo-input-group" :class="inputGroupClassName">
            <div class="goo-control is-expanded">
                <goo-search name="search"
                            input-class="is-large"
                            placeholder="Enter a subject"
                            :items="items"
                            :selected-value="selectedValue"
                            :show-on-focus="true"
                            :min-search-length="0"
                            @search="onSearch"
                            @selectResult="onSelectResult"
                            @clearResult="onClearResult">
                    <template slot-scope="{ result, isHighlighted}">
                        <div class="goo-search-result-title">
                            {{ result.name }}
                        </div>
                    </template>
                </goo-search>
            </div>
            <input v-if="selectedSubject" type="hidden" name="subject" :value="selectedSubject.id"/>
            <div class="goo-control">
                <slot name="button" :isStacked="isStacked">
                    <button type="submit"
                            class="goo-button is-large is-secondary"
                            :class="{'is-full-width' : isStacked}">Get Started
                    </button>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    import SubjectsAPI from "@/api/subjects-api";
    import {GooWindow} from "@gooroo-life/goo-ui-vue";
    import {debounce} from "@/lib/helpers/rate-limiting";

    export default {
        name: "seo-subject-search",
        props: {
            suggestedSubjects: {
                type: Array,
                default() {
                    return [];
                },
            },
            stackBefore: {
                type: Number,
                default: 1024,
            },
        },
        data() {
            return {
                searchResults: [],
                selectedSubject: null,
                currentSearch: null,
            };
        },
        computed: {
            selectedValue() {
                return this.selectedSubject ? this.selectedSubject.name : null;
            },
            items() {
                if (this.currentSearch) {
                    return this.searchResults;
                } else {
                    return this.suggestedSubjects;
                }
            },
            inputGroupClassName() {
                return {
                    "has-joined-controls": !this.isStacked,
                };
            },
            isStacked() {
                return GooWindow.width < this.stackBefore;
            },
        },
        methods: {
            onSearch: debounce(function (search) {
                this.selectedSubject = null;
                this.currentSearch = search;
                if (this.currentSearch.length) {
                    SubjectsAPI.search(this.currentSearch).then(({data}) => {
                        this.searchResults = data;
                    });
                }
            }, 300),
            onSelectResult(result) {
                this.selectedSubject = result;
            },
            onClearResult() {
                this.currentSearch = null;
                this.selectedSubject = null;
            },
        },
        mounted() {
            if (this.suggestedSubjects.length === 1) {
                this.selectedSubject = this.suggestedSubjects[0];
            }
        },
    };
</script>
